const leadPurchase = ['Purchase', {
    content_name: 'Initial Email Collection',
    content_category: 'Lead',
    value: 1,
    currency: 'USD',
}];

const Email = () => (
    <a href="mailto:info@440artists.com" className="text-[#00E387] no-underline">info@440artists.com</a>
);

// Text in [brackets] renders in green. banner: title sits on the banner image above the card.
export const thankYouPages = [
    {
        path: '/application-received/',
        pixelEvent: leadPurchase,
        metaTitle: 'Application Received | 440 Artists',
        description: 'Thanks for applying to 440 Artists. Your application is in and our team will review it soon. Keep an eye on your inbox for next steps.',
        noindex: true,
        title: 'Application [Received]',
        card: 'white',
        body: (
            <>
                <p>
                    Your application has been successfully submitted.<br />
                    Our team reviews every application carefully, and we'll be in touch with next steps soon. You will not be asked for payment unless your application is approved. Keep an eye on your inbox, and if you have any questions in the meantime, feel free to reach out to <Email />.
                </p>
                <p>— Team 440</p>
            </>
        ),
    },
    {
        path: '/thank-you/',
        pixelEvent: leadPurchase,
        metaTitle: 'Thank You | 440 Artists',
        description: 'Your 440 Artists membership payment is confirmed. Check your email for next steps.',
        noindex: true,
        title: 'Thank [You]',
        banner: true,
        card: 'navy',
        body: (
            <>
                <p>
                    We've received your payment. Welcome to 440 Artists! We're thrilled to have you. Check your email for further instructions and next steps. If you have any questions in the meantime, reach out to <Email />.
                </p>
                <p>— Team 440</p>
            </>
        ),
    },
    {
        path: '/thank-you-upgrades/',
        metaTitle: 'Upgrade Confirmed | 440 Artists',
        description: 'Thank you for your purchase.',
        noindex: true,
        title: 'Thank [You]',
        banner: true,
        card: 'navy',
        body: (
            <>
                <p>
                    We've received your upgrade purchase and a receipt has been sent to your email. Our team is reviewing your order now and will follow up shortly with next steps or any additional information needed to get you started.
                </p>
                <p>— The 440 Team</p>
            </>
        ),
    },
];
